<template>
  <v-card>
    <v-card-text class="px-5">
      <v-layout column justify-center>
        <span>Digite sua nova senha abaixo e clique em confirmar.</span>
        <v-form v-model="valid" @submit.prevent="valid && updatePassword()">
          <v-text-field
            label="Nova Senha"
            v-model="newPassword"
            :type="hidePassword ? 'password' : 'text'"
            :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (hidePassword = !hidePassword)"
            :rules="[validationRules.required, validationRules.passwordMinLength]"
          />
        </v-form>
      </v-layout>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer />
      <v-btn flat @click="toggleCardUpdatePassword(false)">
        Cancelar
      </v-btn>
      <v-spacer />
      <v-btn
        class="white--text"
        color="blue"
        @click="updatePassword"
        :disabled="!valid"
      >
        Confirmar
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'card-update-password',
  data() {
    return {
      hidePassword: true,
      newPassword: '',
      valid: false,
      validationRules,
    };
  },
  methods: {
    updatePassword() {
      this.$emit('updatePassword');
    },
    toggleCardUpdatePassword(bool) {
      this.$emit('toggleCardUpdatePassword', bool);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/authentication/password/update/CardUpdatePassword.vue